/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../store/index';

const initialState = {
  visible: false,
};

export const sidenavSlice = createSlice({
  name: 'sidenav',
  initialState,
  reducers: {
    toggleVisibility: (state) => {
      state.visible = !state.visible;
    },
    resetVisibility: (state) => {
      state.visible = false;
    },
  },
  extraReducers: () => {},
});

export const { toggleVisibility, resetVisibility } = sidenavSlice.actions;
export const sidenavSelector = (state: RootState) => state.sidenav;
